import { Component } from "@angular/core";
import { IonicPage, NavController, LoadingController } from "ionic-angular";
import { ServiceProvider } from "../../providers/service/service";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
} from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { Http, RequestOptions, Headers } from "@angular/http";
import { Storage } from "@ionic/storage";
import { SelectLanguagePage } from "./../select-language/select-language";
import { LoginSyncPlatformRegisterPage } from "../login-sync-platform-register/login-sync-platform-register";
import { InAppBrowser } from "@ionic-native/in-app-browser";

@IonicPage()
@Component({
  selector: "page-login-sync-platform",
  templateUrl: "login-sync-platform.html",
})
export class LoginSyncPlatformPage {
  private login: FormGroup;
  theme = 1;

  constructor(
    private services: ServiceProvider,
    private formBuilder: FormBuilder,
    private http: Http,
    private storage: Storage,
    public navCtrl: NavController,
    private translateService: TranslateService,
    private loadingCtrl: LoadingController,
    private iab: InAppBrowser
  ) {
    this.login = this.formBuilder.group({
      username: new FormControl(
        "",
        Validators.compose([
          Validators.required,
          Validators.pattern("^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$"),
        ])
      ),
      password: ["", Validators.compose([Validators.required])],
    });
  }

  async ionViewDidLoad() {
    this.theme = await this.storage.get("theme");
  }

  forget() {
    this.iab.create(
      "http://platform.ingenious-simulation.com/site/request-password-reset",
      "_system"
    );
  }

  syncPlatform() {
    let dataVal = this.login.value;

    if (!dataVal.username || !dataVal.password) {
      this.translateService.get("error blank").subscribe((value) => {
        this.services.presentToast(value);
      });
      return false;
    } else {
      const loader = this.loadingCtrl.create({
        content: "Loading...",
      });
      loader.present();

      this.storage.get("token").then((token) => {
        var link = this.services.URLSync;

        var postData = JSON.stringify({
          email: dataVal.username,
          password: dataVal.password,
        });

        var headers = new Headers();
        headers.append("Accept", "application/json");
        headers.append("Content-Type", "application/json");
        headers.append("Authorization", "Bearer " + token);
        const requestOptions = new RequestOptions({ headers: headers });

        this.http
          .post(link, postData, requestOptions)
          .map((res) => res.json())
          .subscribe(
            (data) => {
              this.storage.set("info", data);

              if (this.storage.set("stepGame", "selectLang")) {
                loader.dismiss();
                this.navCtrl.setRoot(SelectLanguagePage);
              }
            },
            (error) => {
              var response = JSON.parse(error._body);
              loader.dismiss();
              this.translateService
                .get(response[0].message)
                .subscribe((value) => {
                  this.services.presentToast(value);
                });
            }
          );
      });
    }
  }

  register() {
    this.navCtrl.push(LoginSyncPlatformRegisterPage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/login-sync-platform/login-sync-platform.ts